module.exports = __webpack_public_path__ + "img/about.42761a91.jpg";